import api from "../../utils/api";
import { assertCanUseSG } from "./access";

const V5_COMPANY_STATUS = {
  BILLABLE: "jXmjzHcBD5E1J0wjwHzq",
  SUSPENDED: "Y2aD7bE1fF6jM3kO9hP5",
  DELETED: "D4h7DGEqSEXZcG0ByStX",
} as const;

export interface V5CompanyState {
  id: string;
  name: string | null;
  suspended: boolean;
  deleted: boolean;
}

export async function fetchV5CompanyState(
  companyId: string
): Promise<V5CompanyState | null> {
  const { data } = await api.get("/company", { params: { id: companyId } });
  const company = data?.data?.data;
  if (!company) return null;
  return {
    id: company.id,
    name: company.name ?? null,
    suspended: company.status_id === V5_COMPANY_STATUS.SUSPENDED,
    deleted: company.status_id === V5_COMPANY_STATUS.DELETED,
  };
}

export interface V5OperationResult {
  devicesUpdated: number | null;
}

export async function setV5CompanyOperation(
  companyId: string,
  suspend: boolean
): Promise<V5OperationResult> {
  assertCanUseSG();
  const path = suspend ? "/company/suspend" : "/company/activate";
  const { data } = await api.put(path, {}, { params: { id: companyId } });
  const devices = data?.data?.data?.entitiesUpdated?.devices?.updated;
  return { devicesUpdated: typeof devices === "number" ? devices : null };
}
